import type { PoplachConfig } from '../../../api/JsdhNotifikaceService/generated';
import type { MockVariant } from '../../mock/poplachMockData';
import type { Orientace } from '../../../hooks/useOrientaceKontejneru';

// Buildery URL náhledů poplachové obrazovky (/poplach?mock=…). Orientace se posílá vždy,
// aby náhled vypadal stejně z okna na šířku i na výšku (spec kiosek na výšku, kap. 4b).

export interface VlastniNahled {
    varianta: MockVariant;
    technika: string;
    jedu: string;
    nejedu: string;
    posily: string;
    mapaLayout: '' | 'misto' | 'trasa' | 'misto-trasa' | 'off';
    pred: string;
    udalost: string;
    popis: string;
    upresneni: string;
    nocniRezim: '' | 'auto' | 'light' | 'dark';
    pravidla: '' | 'true' | 'false';
}

const sestavUrl = (params: URLSearchParams, orientace: Orientace): string => {
    params.set('orientace', orientace);
    return `/poplach?${params.toString()}`;
};

export const rychlyNahledUrl = (varianta: MockVariant, orientace: Orientace): string => {
    const params = new URLSearchParams();
    params.set('mock', varianta);
    return sestavUrl(params, orientace);
};

// Náhled tlačítko vedle Uložit — otevře /poplach?mock=full s přepisem podle aktuálně editované konfigurace.
export const buildPreviewUrlFromConfig = (cfg: PoplachConfig, orientace: Orientace): string => {
    const params = new URLSearchParams();
    params.set('mock', 'full');
    if (cfg.mapaLayout) params.set('mapaLayout', cfg.mapaLayout);
    if (cfg.nocniRezim) params.set('nocniRezim', cfg.nocniRezim);
    if (cfg.pravidlaVyjezdu?.enabled !== undefined) {
        params.set('pravidla', cfg.pravidlaVyjezdu.enabled ? 'true' : 'false');
    }
    // Mapa zoom konfigurace (relevantní jen pro mapaLayout=misto / misto-trasa)
    if (cfg.mapa?.mode) params.set('mapMode', cfg.mapa.mode);
    if (cfg.mapa?.fixedZoom !== undefined) params.set('fixedZoom', String(cfg.mapa.fixedZoom));
    if (cfg.mapa?.zoom1 !== undefined) params.set('zoom1', String(cfg.mapa.zoom1));
    if (cfg.mapa?.zoom2 !== undefined) params.set('zoom2', String(cfg.mapa.zoom2));
    if (cfg.mapa?.interval !== undefined) params.set('interval', String(cfg.mapa.interval));
    return sestavUrl(params, orientace);
};

export const buildCustomMockUrl = (v: VlastniNahled, orientace: Orientace): string => {
    const params = new URLSearchParams();
    params.set('mock', v.varianta);
    if (v.technika.trim()) params.set('technika', v.technika.trim());
    if (v.jedu.trim()) params.set('jedu', v.jedu.trim());
    if (v.nejedu.trim()) params.set('nejedu', v.nejedu.trim());
    if (v.posily.trim()) params.set('posily', v.posily.trim());
    if (v.mapaLayout) params.set('mapaLayout', v.mapaLayout);
    if (v.pred.trim()) params.set('pred', v.pred.trim());
    if (v.udalost.trim()) params.set('udalost', v.udalost.trim());
    if (v.popis.trim()) params.set('popis', v.popis.trim());
    if (v.upresneni.trim()) params.set('upresneni', v.upresneni.trim());
    if (v.nocniRezim) params.set('nocniRezim', v.nocniRezim);
    if (v.pravidla) params.set('pravidla', v.pravidla);
    return sestavUrl(params, orientace);
};
